module.exports = __webpack_public_path__ + "img/ic_share_wa.aa475b25.svg";